<mat-form-field appearance="fill" class="listing-filters-item">
  <mat-label>{{ facet.key }}</mat-label>
  <mat-select [formControl]="facetFC" multiple>
    <mat-option
      *ngFor="let option of facet.values; let i = index; trackBy: trackByFn"
      (onSelectionChange)="onSelectionChange(option, $event)"
      [value]="option.key"
      [disabled]="option.disabled"
    >
      {{ option.key }} ({{ option.count }})
    </mat-option>
  </mat-select>
</mat-form-field>
